import styled from 'styled-components';

import media from 'apps/auth/theme/media';

export const GaCardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    ${media.tablet937} {
        flex-direction: row;
        margin: 0 -16px;
    }

    ${media.desktop1224} {
        flex-direction: column;
    }

    ${media.desktop1296} {
        flex-direction: row;
    }
`;

export const GaCardsItem = styled.div`
    margin-bottom: 24px;
    box-sizing: border-box;
    display: flex;
    max-width: 100%;

    ${media.tablet720} {
        margin-bottom: 32px;
    }

    ${media.tablet937} {
        width: 50%;
        padding: 0 16px;
    }

    ${media.desktop1224} {
        width: 100%;
        padding: 0;
    }

    ${media.desktop1296} {
        width: 50%;
        padding: 0 16px;
    }
`;
